import appHeaderActions from "../../actions/appHeader";

export default {
  register(obj) {
    appHeaderActions.subMenuItemCreate(obj);
  }
};
